<img
    class="mw-100 d-none d-md-block"
    [src]="imageSrc"
    alt="{{ title || 'Banner image' }}"
/>
<h2
    class="container-card-landing-title-title position-absolute top-50 start-50 fw-bold mb-0 text-center"
    [ngClass]="{
        'placeholder placeholder-wave w-25': !title
    }"
>
    {{ title || 'xxxxxxxx' }}
</h2>
